export const fileDownloadURL = 'http://198.38.85.240:2077/sampleExcelFile/';

// export const fileDownloadURL = 'http://192.168.1.41:3499/sampleExcelFile/';
